import { render, staticRenderFns } from "./BudgetLineApprovalModal.vue?vue&type=template&id=23956054"
import script from "./BudgetLineApprovalModal.vue?vue&type=script&lang=js"
export * from "./BudgetLineApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports